export default "__VITE_ASSET__RSwCWca3__"